import React from "react";

const CardProfile = ({ label, value, iconImage }) => {
	require("./Ensa.css");
	return (
		<div className="card-profile">
			<div>
				<img src={iconImage} width="40px" alt="" />
			</div>
			<div>
				<span className="label-profile-value">{label}</span>
				<p className="label-profile-name">{value}</p>
			</div>
		</div>
	);
};

export default CardProfile;
